import { Button, RefreshCw, Tooltip } from '@chain-zen/ui'

interface SendAppDownloadLinkButtonProps {
  canSendAppDownloadLink: boolean
  compact?: boolean
  onSendDownloadAppLink: () => void
  sendingAppDownloadLink: boolean
}

/**
 * The component that displays a button to send the app download link
 */
export const SendAppDownloadLinkButton = ({
  canSendAppDownloadLink,
  compact = false,
  onSendDownloadAppLink,
  sendingAppDownloadLink
}: SendAppDownloadLinkButtonProps) => {
  const buttonText = compact ? 'Send SMS' : 'Send App Download SMS'

  return (
    <Tooltip
      content={
        canSendAppDownloadLink
          ? 'Click on the button to send the app download link'
          : 'You have reached the maximum limit of 5 notifications for this shipment.'
      }
      side="bottom"
    >
      <Button
        variant="outline"
        onClick={onSendDownloadAppLink}
        disabled={!canSendAppDownloadLink}
        size="xs"
        className="h-7 whitespace-nowrap px-3"
      >
        {sendingAppDownloadLink ? (
          <>
            <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
            Sending...
          </>
        ) : (
          buttonText
        )}
      </Button>
    </Tooltip>
  )
}
